// for unassigment of employee

export const RESER_UNASSIGN_EMPLOYEE = "resign_unassign_employee";
export const UNASSIGN_EMPLOYEE = "unassign_employee";
export const UNASSIGN_EMPLOYEE_SUCCESS = "unassign_employee_success";
export const UNASSIGN_EMPLOYEE_FAILURE = "unassign_employee_failure";
